import Swiper, {Navigation} from 'swiper';

Swiper.use([Navigation]);

export default function swipers() {
    new Swiper('.js-exclusive-gallery', {
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
            nextEl: '.swiper-buttons-custom--next',
            prevEl: '.swiper-buttons-custom--prev',
        },
        on: {
            init(swiper) {
                if (swiper.slides.length <= 1) {
                    swiper.el
                        .querySelectorAll('.swiper-buttons-custom--next, .swiper-buttons-custom--prev')
                        .forEach(btn => btn.style.display = 'none');
                }
            }
        }

    });
    new Swiper('.js-team-swiper', {
        slidesPerView: 1.1,
        spaceBetween: 15,
        navigation: {
            nextEl: '.swiper-buttons-custom--next',
            prevEl: '.swiper-buttons-custom--prev',
        },
        on: {
            init(swiper) {
                if (swiper.slides.length <= 1) {
                    swiper.el
                        .querySelectorAll('.swiper-buttons-custom--next, .swiper-buttons-custom--prev')
                        .forEach(btn => btn.style.display = 'none');
                }
            }
        },
        breakpoints: {
            550: {
                spaceBetween: 24,
                slidesPerView: 3,
            }
        }

    });
}